import React from 'react'
import { SgReadyIcon } from '@e3dc-react/icons'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Box, Divider, Stack, useMediaQuery, useTheme } from '@mui/material'
import { SgReadyBadge } from 'src/Libs/ai-360/components'
import { EmsSgReadyMode } from 'src/Libs/dynamic-power-prices/types'

interface Props {
  sgReadyStatus: EmsSgReadyMode | null
  showSgReadyBadge: boolean
  isDynamicPowerPriceEnabledForFarm: boolean
  threeSixtyAutarkyHintKey: string
  isLoading?: boolean
  isNewLiveValuesEnabled?: boolean
}

/**
 * Presentational SG-ready badge / dynamic-price hint for the live view. Rendered by SgReadyBadgeForLiveView and reused in Storybook.
 */
const SgReadyBadgeView: React.FC<Props> = ({
  sgReadyStatus,
  showSgReadyBadge,
  isDynamicPowerPriceEnabledForFarm,
  threeSixtyAutarkyHintKey,
  isLoading = false,
  isNewLiveValuesEnabled = false,
}) => {
  const theme = useTheme()
  const upSm = useMediaQuery(theme.breakpoints.up('sm'))

  if (!showSgReadyBadge && !isDynamicPowerPriceEnabledForFarm) return null

  if (upSm) {
    return (
      <>
        {showSgReadyBadge && (sgReadyStatus !== null || isLoading) && (
          <Divider
            sx={{
              borderColor: 'grey.grey06',
              marginLeft: -4,
              marginRight: -4,
            }}
          />
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            pb: 2,
            pt: 2,
          }}
        >
          {isDynamicPowerPriceEnabledForFarm && <Typography variant="caption">{threeSixtyAutarkyHintKey}</Typography>}
          {showSgReadyBadge && (sgReadyStatus !== null || isLoading) && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              <SgReadyIcon /> <SgReadyBadge status={sgReadyStatus} isLoading={isLoading} />
            </Box>
          )}
        </Box>
      </>
    )
  }

  return (
    <Stack gap={2} mb={2} mt={isNewLiveValuesEnabled ? 0 : 2}>
      {isDynamicPowerPriceEnabledForFarm && <Typography variant="caption">{threeSixtyAutarkyHintKey}</Typography>}
      {showSgReadyBadge && (sgReadyStatus !== null || isLoading) && (
        <>
          <Divider
            sx={{
              borderColor: 'grey.grey06',
              marginLeft: -4,
              marginRight: -4,
            }}
          />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <SgReadyIcon /> <SgReadyBadge status={sgReadyStatus} isLoading={isLoading} />
          </Box>
        </>
      )}
    </Stack>
  )
}

export default SgReadyBadgeView
